'use strict';

const PROTECTED_REGEXP = /^\/api_v1\/.+/;
const authInterceptor = [
  '$q',
  'session',
  'logout',

  function ($q, session, logout) {
    return {
      responseError: function (response) {
        if (response.status === 401 && isProtected(response.config.url)) {
          logout();
        }

        return $q.reject(response);
      }
    };
  }
];

function isProtected(url) {
  return PROTECTED_REGEXP.test(url);
}

export default authInterceptor;



// WEBPACK FOOTER //
// ./app/src/services/auth_interceptor.js